import { Alert, Button, Paper, Stack, Typography } from "@mui/material";

import type { ClientCdpMergeSuggestion } from "../../../../lib/api/types";
import { matchTypeLabel } from "./Client360CdpMasterBanner";

export default function Client360MergeSuggestionsCard({
    canManage,
    currentProfileId,
    onApprove,
    onReject,
    suggestions,
}: {
    canManage: boolean;
    currentProfileId: string;
    suggestions: ClientCdpMergeSuggestion[];
    onApprove: (suggestionId: number) => Promise<void>;
    onReject: (suggestionId: number) => Promise<void>;
}) {
    if (suggestions.length === 0) {
        return (
            <Alert severity="info">
                Няма чакащи предложения за свързване. Админът може да пусне detect SQL върху Partners.
            </Alert>
        );
    }

    return (
        <Stack spacing={1.5}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                Предложения за свързване
            </Typography>
            {suggestions.map((item) => {
                const otherProfileId = item.profileIdA === currentProfileId ? item.profileIdB : item.profileIdA;
                const otherName = item.profileIdA === currentProfileId ? item.customerNameB : item.customerNameA;

                return (
                    <Paper key={item.id} variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {otherName || otherProfileId}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                            Съвпадение по {matchTypeLabel(item.matchType)}: {item.matchKey}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Partner {item.partnerIdA} ↔ {item.partnerIdB}
                        </Typography>
                        {canManage ? (
                            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                                <Button size="small" variant="contained" onClick={() => onApprove(item.id)}>
                                    Потвърди
                                </Button>
                                <Button size="small" variant="outlined" onClick={() => onReject(item.id)}>
                                    Отхвърли
                                </Button>
                            </Stack>
                        ) : null}
                    </Paper>
                );
            })}
        </Stack>
    );
}
